// Cómo se nombra el estado de un trabajo en los PDF y exportaciones (26-oct-2026). Antes solo se conocían
// REALIZADO y PRESUPUESTO (los de la app vieja): un trabajo hecho y sin cobrar (COMPLETADO) salía "Rechazado".
export const HECHOS = ['COMPLETADO', 'PENDIENTE_FACTURACION', 'FACTURADO', 'COBRADO', 'REALIZADO'];

export function estadoTrabajo(e) {
    if (e === 'COBRADO' || e === 'REALIZADO') return { label: e === 'COBRADO' ? 'Pagado' : 'Realizado', color: 'green' };
    if (e === 'COMPLETADO' || e === 'PENDIENTE_FACTURACION' || e === 'FACTURADO') return { label: 'Pendiente de pago', color: 'gold' };
    if (e === 'EN_PROGRESO') return { label: 'En curso', color: 'gold' };
    if (e === 'APROBADO') return { label: 'Aprobado', color: 'gold' };
    if (e === 'PRESUPUESTO') return { label: 'Presupuesto', color: 'gold' };
    return { label: 'Cancelado', color: 'red' };
}
